import { Button, Checkbox, Col, Form, Row, Space } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { showError, showMessage, useLayoutBreaks } from "helpers/utility";
import useAjax from "helpers/ajax";
import CInput from "components/CInput";

const CreateRole = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const breaks = useLayoutBreaks();
  const { fetch } = useAjax();
  const edit = state ? true : false;

  const onFinish = (values) => {
    const method = edit ? "put" : "post";
    const data = { ...values, roleID: state?.roleID };
    fetch(method, "api/v1/roles", { ...data })
      .then((resp) => {
        showMessage(resp.success, resp.message).then(() => {
          if (resp.success) {
            navigate("/security/roles");
          }
        });
      })
      .catch((err) => {
        showError(err);
      });
  };

  return (
    <Form
      layout="vertical"
      initialValues={{ ...state, active: !edit ? true : state.active }}
      onFinish={onFinish}
    >
      <Row gutter={24}>
        <Col {...breaks}>
          <Form.Item
            label="Role name"
            name="roleName"
            rules={[{ required: true }]}
          >
            <CInput />
          </Form.Item>
          <Form.Item valuePropName="checked" label="Active" name="active">
            <Checkbox />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                Save
              </Button>
              <Button
                htmlType="button"
                onClick={() => {
                  navigate("/security/roles");
                }}
              >
                Cancel
              </Button>
            </Space>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
export default CreateRole;
